// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"736":"chartjs","744":"actioncable"}[chunkId] || chunkId) + "-" + {"19":"16e0e532080c33600269","736":"7ad1d719b0577fdeccd0","744":"61f9600ba6964ee4ae75"}[chunkId] + ".chunk.js";
};